import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Text from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'

const CheckoutDrawerTitle = ({
  title,
  expandedTitle,
  subtitle,
  expandedSubtitle,
  step,
  expanded,
  isDone = true,
  isActive,
  seeEdit,
  noIcon,
  threeStepper
}) =>
  <DrawerTitleWrapper seeEdit={ seeEdit }>
    <Heading noMargin ellipsis={ expanded && seeEdit }>
      <Circle disabled={ !isActive } hideIcon={ noIcon } addBottom={ isDone && !expanded }>
        {
          (isDone && !expanded) ?
            <CheckIcon asset="check-white" /> :
            <Number>{ step }</Number>
        }
      </Circle>
      <Title disabled={ !isActive } expanded={ isActive && expanded }>{ expanded ? expandedTitle : title }</Title>
    </Heading>
    {
      !expanded && isDone &&
      <Subtitle noIcon={ noIcon } threeStepper={ threeStepper }>{ subtitle }</Subtitle>
    }
    {
      expanded && expandedSubtitle &&
      <Subtitle expandedSubtitle>{ expandedSubtitle }</Subtitle>
    }
  </DrawerTitleWrapper>

export default CheckoutDrawerTitle

CheckoutDrawerTitle.propTypes = {
  expanded: PropTypes.bool,
  expandedSubtitle: PropTypes.string,
  expandedTitle: PropTypes.string,
  isActive: PropTypes.bool,
  isDone: PropTypes.bool,
  noIcon: PropTypes.bool,
  seeEdit: PropTypes.bool,
  step: PropTypes.number,
  subtitle: PropTypes.string,
  threeStepper: PropTypes.bool,
  title: PropTypes.string
}

const Title = styled(Text)`
  ${Mixin.font.GothamBold(14)}
  ${props => props.disabled && css`
    color: ${Theme.colors.grey};
  `}
  ${props => props.expanded && css`
    text-decoration: underline;
  `}
`

const Circle = styled.div`
  display: inline-block;
  background-color: ${Theme.colors.green};
  border-radius: 10px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  vertical-align: middle;
  ${props => props.disabled && css`
    background-color: ${Theme.colors.grey};
  `}
  ${props => props.hideIcon && css`
    display: none;
  `}
  ${props => props.addBottom && css`
    position: relative;
    bottom: 3px;
  `}
`

const CheckIcon = styled(Icon)`
  position: relative;
  top: 3px;
  width: 21px;
  height: 11px;
  vertical-align: unset;
`

const Number = styled.div`
  ${Mixin.font.GothamBold(14, 600, 18)}
  text-align: center;
  color: white;
`

const DrawerTitleWrapper = styled.div`
  width: 80%;
  white-space: nowrap;
  text-transform: none;
  ${Mixin.font.GothamBold()}
  ${props => props.seeEdit && css`
    ${Media.mobile`
      width: 70%;
    `}
  `}
`

const Heading = styled(Text)`
  display: inline-block;
  margin-bottom: 5px;
  ${props => props.ellipsis && css`
    ${Media.mobile`
      ${Mixin.ellipsis()}
    `}
  `}
`

const Subtitle = styled(Heading)`
  margin-bottom: 5px;

  && {
    white-space: normal;
  }

  ${props => !props.expandedSubtitle && css`
    ${Mixin.ellipsis()}
  `}
  ${props => props.noIcon && css`
    margin-top: 5px;
  `}
  ${props => props.threeStepper && css`
    line-height: 20px;
  `}
`.withComponent('div')
